
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs

/**
 * Module qui gère principalement l'état de chargement des éléments ".pill-button".
 */
export default class FF_Pill_Button extends FF_Module {

  /***
   *
   *       ##   #####  #####     #       ####    ##   #####  # #    #  ####      ####  #####   ##   ##### ######
   *      #  #  #    # #    #    #      #    #  #  #  #    # # ##   # #    #    #        #    #  #    #   #
   *     #    # #    # #    #    #      #    # #    # #    # # # #  # #          ####    #   #    #   #   #####
   *     ###### #    # #    #    #      #    # ###### #    # # #  # # #  ###         #   #   ######   #   #
   *     #    # #####  #####     ######  ####  #    # #####  # #    #  ####      ####    #   #    #   #   ######
   */
  /**
   * Ajoute l'état de chargement et exécute l'animation relié à celui-ci.
   * @returns {Promise} Promise résolue lorsque l'animation est terminée.
   */
  add_loading_state() {
    return new Promise((resolve) => {

      if ($(this.elements.container).hasClass('pill-button--loading')) {
        resolve();
        return;
      }
      $(this.elements.container).addClass('pill-button--loading');

      // =======================================================================
      // Ajoute les flèches défilantes
      // =======================================================================
      const arrows_container = document.createElement('span');
      for (let i = 0; i < 8; i++) {
        const $icon = $('.arrow-line-icon').clone();
        $icon
          .css({
            left   : 0,
            padding: '0 0.75em',
            width  : '4em',
            height : 'auto'
          })
          .appendTo(arrows_container);
        gsap.set($icon.find('path'), { x: '-3.5em' });
      }
      $(arrows_container)
        .addClass('pill-button__loading-arrows')
        .css({
          position  : 'absolute',
          right     : 0,
          display   : 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap'
        })
        .appendTo($(this.elements.container).find('.pill-button__hover-text-container'));

      // =======================================================================
      // Animation de transition
      // =======================================================================
      const tl = gsap.timeline({ onComplete: resolve });

      // Cache le texte et affiche les flèche
      tl.to($(this.elements.container).find('.pill-button__hover-text span'), { y: '100%', ease: 'power2.in', duration: 0.425 });
      tl.fromTo($(arrows_container).find('.arrow-line-icon path'), { x: '-3.5em' }, { x: 0, ease: 'expo.out', duration: 1.5, delay: 0.25 }, 0.25);

      // =======================================================================
      // Animation en continu
      // =======================================================================
      gsap.to(arrows_container, {
        duration: 5,
        ease    : 'none',
        x       : gsap.utils.snap($(arrows_container).find('.arrow-line-icon').innerWidth(), $(arrows_container).innerWidth() - $(this.elements.container).innerWidth()),
        repeat  : -1
      });

    });
  }

  /***
   *     #####  ###### #    #  ####  #    # ######    #       ####    ##   #####  # #    #  ####      ####  #####   ##   ##### ######
   *     #    # #      ##  ## #    # #    # #         #      #    #  #  #  #    # # ##   # #    #    #        #    #  #    #   #
   *     #    # #####  # ## # #    # #    # #####     #      #    # #    # #    # # # #  # #          ####    #   #    #   #   #####
   *     #####  #      #    # #    # #    # #         #      #    # ###### #    # # #  # # #  ###         #   #   ######   #   #
   *     #    # ###### #    #  ####    ##   ######    ######  ####  #    # #####  # #    #  ####      ####    #   #    #   #   ######
   */
  /**
   * Retire l'état de chargement et exécute l'animation relié à celui-ci.
   * @returns {Promise} Promise résolue lorsque l'animation est terminée.
   */
  remove_loading_state() {
    return new Promise((resolve) => {

      if (!$(this.elements.container).hasClass('pill-button--loading')) {
        resolve();
        return;
      }

      const tl = gsap.timeline({ onComplete: resolve });
      gsap.killTweensOf($(this.elements.container).find('.pill-button__loading-arrows .arrow-line-icon path'));

      tl.to($(this.elements.container).find('.pill-button__loading-arrows .arrow-line-icon path'), {
        x         : '-3.5em',
        ease      : 'power3.in',
        duration  : 0.6,
        onComplete: () => {
          gsap.to($(this.elements.container).find('.pill-button__hover-text span'), { y: 0, ease: 'expo.out', duration: 1, clearProps: 'all', onComplete: () => $(this.elements.container).css('pointerEvents', '') });
          $(this.elements.container)
            .removeClass('pill-button--loading')
            .find('.pill-button__loading-arrows')
            .remove();
        }
      });
      tl.to($(this.elements.container).find('.pill-button__hover-text span'), { y: 0, ease: 'expo.out', duration: 1, clearProps: 'all' });
      tl.call(() => {
        $(this.elements.container)
          .removeClass('pill-button--loading')
          .find('.pill-button__loading-arrows')
          .remove();
      });

    });
  }

}
